import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import di from "../../../../dependency_injection";
import dateDto from "../../../dto/date.dto";

const downloadHumanAgentResumeApiImpl = async (_: {
  agentId: string;
  startDate?: Date;
  endDate?: Date;
}): Promise<Either<ErrorEntity, void>> => {
  try {
    let relativeUrl = "/stats/export/details";
    relativeUrl += `?human_agent_id=${_.agentId}`;
    if (_.startDate) relativeUrl += `&start_date=${dateDto.toServer(_.startDate)}`;
    if (_.endDate) relativeUrl += `&end_date=${dateDto.toServer(_.endDate)}`;

    // Realizar la solicitud al backend
    const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
      responseType: "blob", // Esto puede ser ignorado si tu HostApi usa fetch, pero lo dejamos por claridad
    });

    const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    // Obtener el blob desde la respuesta
    // const blob = await response.blob();

    // Descargar el archivo
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const fileName = `${_.agentId}_${_.startDate?.toISOString().split("T")[0] ?? "no_start_date"}_to_${(_.endDate ?? new Date())?.toISOString().split("T")[0]}_resume.xlsx`;

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return right(undefined);
  } catch (error) {
    console.error("downloadHumanAgentResumeApiImpl", error);
    return left(ErrorEntity.fromError(error));
  }
};

export default downloadHumanAgentResumeApiImpl;
